import { observer } from 'mobx-react';
import * as React from 'react';
import ReactModal from 'react-modal';

const styles = require('./modal.css');

interface ModalProps extends ReactModal.Props {
  kind?: 'editor' | 'standard';
}

/**
 * Modal - Futurefit modal, doesn't cover the header
 */
@observer
export class Modal extends React.Component<ModalProps> {
  render(): JSX.Element {
    return (
      <ReactModal
        className={this.props.kind === 'editor' ? styles.editorContent : styles.content}
        overlayClassName={styles.overlay}
        {...this.props}
      >
        {this.props.children}
      </ReactModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modal/modal.tsx